import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-curd-resource',
  templateUrl: './curd-resource.component.html',
  styleUrls: ['./curd-resource.component.css']
})
export class CurdResourceComponent {
 resourceForm: FormGroup;
 mode: 'add' | 'edit' | 'view' = 'add'; // switch this as needed
  resourceId: string | null = null;

  constructor(private route: ActivatedRoute, private fb: FormBuilder) {
    this.resourceForm = this.fb.group({
      companyName: ['', Validators.required],
      domain: ['', Validators.required],
      keyContact: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      address: ['', Validators.required],
      mobileNumber: ['', [Validators.required, Validators.pattern(/^[0-9+\- ]{7,15}$/)]],
      email: ['', [Validators.required, Validators.email]],
      employeeNumber: ['', Validators.required],
      designation: [''],
      role: [''],
      projectReference: [''],
      client: [''],
      projectStartDate: ['', Validators.required],
      projectEndDate: ['', Validators.required]
    });
  }
ngOnInit() {
    // Get mode from route data
    this.mode = this.route.snapshot.data['mode'] || 'add';

    // Get ID for edit/view
    this.resourceId = this.route.snapshot.paramMap.get('id');

    this.buildForm();

    if (this.mode === 'edit' || this.mode === 'view') {
      // Fetch resource by ID (mock here)
      const mockData = {
        companyName: 'ABC Corp',
        domain: 'Telecom',
        keyContact: 'John Doe',
        firstName: 'John',
        lastName: 'Doe',
        address: '123 Street',
        mobileNumber: '+1234567890',
        email: 'john@example.com',
        employeeNumber: 'EMP001',
        designation: 'Engineer',
        role: 'Admin',
        projectReference: 'Project X',
        client: 'Client Y',
        projectStartDate: '2024-01-01',
        projectEndDate: '2024-12-31',
      };
      this.resourceForm.patchValue(mockData);
    }

    if (this.mode === 'view') {
      this.resourceForm.disable();
    }
  }

  buildForm() {
    this.resourceForm = this.fb.group({
      companyName: ['', Validators.required],
      domain: ['', Validators.required],
      keyContact: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      address: ['', Validators.required],
      mobileNumber: ['', [Validators.required, Validators.pattern(/^[0-9+\- ]{7,15}$/)]],
      email: ['', [Validators.required, Validators.email]],
      employeeNumber: ['', Validators.required],
      designation: [''],
      role: [''],
      projectReference: [''],
      client: [''],
      projectStartDate: ['', Validators.required],
      projectEndDate: ['', Validators.required],
    });
  }

  onSubmit() {
    if (this.resourceForm.valid) {
      console.log(`${this.mode === 'edit' ? 'Updating' : 'Adding'} resource:`, this.resourceForm.value);
      // Handle API call
    } else {
      this.resourceForm.markAllAsTouched();
    }
  }
}